import BaseSlider from './BaseSlider.vue';

export { BaseSlider };
